import React, { useContext } from "react"
import _ from "lodash"
import { Link } from "react-router-dom"

import MenuItem from "./MenuItem"
import { LoaderProgressBar } from "../../Loaders"

import { UserContext } from "../../../context/userContext"

// hooks
import useMenuItems from "./hooks/useMenuItems"

export default function ParticipantMenu() {
  const { current_participant_id, participant_membership_status } =
    useContext(UserContext)
  const [loading, items] = useMenuItems("participant")

  if (current_participant_id === null) return null
  if (loading) return <LoaderProgressBar />

  return (
    <div className="navbar-participants">
      <ul className="first-level">
        {_.map(items.filter(Boolean), (firstLevel, i) => {
          const { label, path, icon, items } = firstLevel
          const hasSubMenu = !_.isEmpty(items)

          const isDischargePath = path === "/form/discharge_session/1"
          const isParticipantDischarge =
            participant_membership_status === "Inactive Discharged"

          if (isDischargePath && isParticipantDischarge) return null

          if (hasSubMenu) {
            return (
              <li key={i}>
                <a href="#">
                  <span className="material-icons">{icon}</span>
                  {label}
                  <span className="material-icons right-arrow">
                    chevron_right
                  </span>
                </a>
                <ul className="second-level">
                  {_.map(items, (secondLevel, i) => (
                    <li key={`second-level-${i}`}>
                      <Link to={secondLevel.path}>{secondLevel.label}</Link>
                    </li>
                  ))}
                </ul>
              </li>
            )
          }

          return <MenuItem key={i} path={path} icon={icon} label={label} />
        })}
      </ul>
    </div>
  )
}
